"use strict";

var _regeneratorRuntime = require("/vercel/path0/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/web/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _ImageDrawer_images;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageDrawer = void 0;

var Utils_1 = require("../../Utils");

var Enums_1 = require("../../Enums");

var Utils_2 = require("./Utils");

var ImageDrawer = /*#__PURE__*/function () {
  function ImageDrawer() {
    _classCallCheck(this, ImageDrawer);

    _ImageDrawer_images.set(this, void 0);

    __classPrivateFieldSet(this, _ImageDrawer_images, [], "f");
  }

  _createClass(ImageDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "getImages",
    value: function getImages(container) {
      var containerImages = __classPrivateFieldGet(this, _ImageDrawer_images, "f").find(function (t) {
        return t.id === container.id;
      });

      if (!containerImages) {
        __classPrivateFieldGet(this, _ImageDrawer_images, "f").push({
          id: container.id,
          images: []
        });

        return this.getImages(container);
      } else {
        return containerImages;
      }
    }
  }, {
    key: "addImage",
    value: function addImage(container, image) {
      var containerImages = this.getImages(container);
      containerImages === null || containerImages === void 0 ? void 0 : containerImages.images.push(image);
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(container) {
        var _iterator, _step, manualParticle, emitterOptions, _iterator2, _step2, emitter, interactiveEmitters, _iterator3, _step3, _emitter;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadImagesFromParticlesOptions(container, container.actualOptions.particles);

              case 2:
                _context.next = 4;
                return this.loadImagesFromParticlesOptions(container, container.actualOptions.interactivity.modes.trail.particles);

              case 4:
                _iterator = _createForOfIteratorHelper(container.actualOptions.manualParticles);
                _context.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context.next = 13;
                  break;
                }

                manualParticle = _step.value;
                _context.next = 11;
                return this.loadImagesFromParticlesOptions(container, manualParticle.options);

              case 11:
                _context.next = 7;
                break;

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](5);

                _iterator.e(_context.t0);

              case 18:
                _context.prev = 18;

                _iterator.f();

                return _context.finish(18);

              case 21:
                emitterOptions = container.actualOptions;

                if (!emitterOptions.emitters) {
                  _context.next = 45;
                  break;
                }

                if (!(emitterOptions.emitters instanceof Array)) {
                  _context.next = 43;
                  break;
                }

                _iterator2 = _createForOfIteratorHelper(emitterOptions.emitters);
                _context.prev = 25;

                _iterator2.s();

              case 27:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 33;
                  break;
                }

                emitter = _step2.value;
                _context.next = 31;
                return this.loadImagesFromParticlesOptions(container, emitter.particles);

              case 31:
                _context.next = 27;
                break;

              case 33:
                _context.next = 38;
                break;

              case 35:
                _context.prev = 35;
                _context.t1 = _context["catch"](25);

                _iterator2.e(_context.t1);

              case 38:
                _context.prev = 38;

                _iterator2.f();

                return _context.finish(38);

              case 41:
                _context.next = 45;
                break;

              case 43:
                _context.next = 45;
                return this.loadImagesFromParticlesOptions(container, emitterOptions.emitters.particles);

              case 45:
                interactiveEmitters = emitterOptions.interactivity.modes.emitters;

                if (!interactiveEmitters) {
                  _context.next = 69;
                  break;
                }

                if (!(interactiveEmitters instanceof Array)) {
                  _context.next = 67;
                  break;
                }

                _iterator3 = _createForOfIteratorHelper(interactiveEmitters);
                _context.prev = 49;

                _iterator3.s();

              case 51:
                if ((_step3 = _iterator3.n()).done) {
                  _context.next = 57;
                  break;
                }

                _emitter = _step3.value;
                _context.next = 55;
                return this.loadImagesFromParticlesOptions(container, _emitter.particles);

              case 55:
                _context.next = 51;
                break;

              case 57:
                _context.next = 62;
                break;

              case 59:
                _context.prev = 59;
                _context.t2 = _context["catch"](49);

                _iterator3.e(_context.t2);

              case 62:
                _context.prev = 62;

                _iterator3.f();

                return _context.finish(62);

              case 65:
                _context.next = 69;
                break;

              case 67:
                _context.next = 69;
                return this.loadImagesFromParticlesOptions(container, interactiveEmitters.particles);

              case 69:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 15, 18, 21], [25, 35, 38, 41], [49, 59, 62, 65]]);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      __classPrivateFieldSet(this, _ImageDrawer_images, [], "f");
    }
  }, {
    key: "loadImagesFromParticlesOptions",
    value: function () {
      var _loadImagesFromParticlesOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(container, options) {
        var _a, _b, _c, shapeOptions, idx, imageOptions, _iterator4, _step4, optionsImage, groupName, group;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                shapeOptions = options === null || options === void 0 ? void 0 : options.shape;

                if (!(!(shapeOptions === null || shapeOptions === void 0 ? void 0 : shapeOptions.type) || !shapeOptions.options || !(0, Utils_1.isInArray)(Enums_1.ShapeType.image, shapeOptions.type) && !(0, Utils_1.isInArray)(Enums_1.ShapeType.images, shapeOptions.type))) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                idx = __classPrivateFieldGet(this, _ImageDrawer_images, "f").findIndex(function (t) {
                  return t.id === container.id;
                });

                if (idx >= 0) {
                  __classPrivateFieldGet(this, _ImageDrawer_images, "f").splice(idx, 1);
                }

                imageOptions = (_a = shapeOptions.options[Enums_1.ShapeType.images]) !== null && _a !== void 0 ? _a : shapeOptions.options[Enums_1.ShapeType.image];

                if (!(imageOptions instanceof Array)) {
                  _context2.next = 26;
                  break;
                }

                _iterator4 = _createForOfIteratorHelper(imageOptions);
                _context2.prev = 8;

                _iterator4.s();

              case 10:
                if ((_step4 = _iterator4.n()).done) {
                  _context2.next = 16;
                  break;
                }

                optionsImage = _step4.value;
                _context2.next = 14;
                return this.loadImageShape(container, optionsImage);

              case 14:
                _context2.next = 10;
                break;

              case 16:
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](8);

                _iterator4.e(_context2.t0);

              case 21:
                _context2.prev = 21;

                _iterator4.f();

                return _context2.finish(21);

              case 24:
                _context2.next = 28;
                break;

              case 26:
                _context2.next = 28;
                return this.loadImageShape(container, imageOptions);

              case 28:
                if (!(options === null || options === void 0 ? void 0 : options.groups)) {
                  _context2.next = 37;
                  break;
                }

                _context2.t1 = _regeneratorRuntime.keys(options.groups);

              case 30:
                if ((_context2.t2 = _context2.t1()).done) {
                  _context2.next = 37;
                  break;
                }

                groupName = _context2.t2.value;
                group = options.groups[groupName];
                _context2.next = 35;
                return this.loadImagesFromParticlesOptions(container, group);

              case 35:
                _context2.next = 30;
                break;

              case 37:
                if (!((_c = (_b = options === null || options === void 0 ? void 0 : options.destroy) === null || _b === void 0 ? void 0 : _b.split) === null || _c === void 0 ? void 0 : _c.particles)) {
                  _context2.next = 40;
                  break;
                }

                _context2.next = 40;
                return this.loadImagesFromParticlesOptions(container, options === null || options === void 0 ? void 0 : options.destroy.split.particles);

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 18, 21, 24]]);
      }));

      function loadImagesFromParticlesOptions(_x2, _x3) {
        return _loadImagesFromParticlesOptions.apply(this, arguments);
      }

      return loadImagesFromParticlesOptions;
    }()
  }, {
    key: "loadImageShape",
    value: function () {
      var _loadImageShape = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(container, imageShape) {
        var imageFunc, image;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                imageFunc = imageShape.replaceColor ? Utils_2.downloadSvgImage : Utils_2.loadImage;
                _context3.next = 4;
                return imageFunc(imageShape.src);

              case 4:
                image = _context3.sent;

                if (image) {
                  this.addImage(container, image);
                }

                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                console.warn("tsParticles error - ".concat(imageShape.src, " not found"));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function loadImageShape(_x4, _x5) {
        return _loadImageShape.apply(this, arguments);
      }

      return loadImageShape;
    }()
  }, {
    key: "draw",
    value: function draw(context, particle, radius, opacity) {
      var _a, _b;

      if (!context) {
        return;
      }

      var image = particle.image;
      var element = (_a = image === null || image === void 0 ? void 0 : image.data) === null || _a === void 0 ? void 0 : _a.element;

      if (!element) {
        return;
      }

      var ratio = (_b = image === null || image === void 0 ? void 0 : image.ratio) !== null && _b !== void 0 ? _b : 1;
      var pos = {
        x: -radius,
        y: -radius
      };

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = opacity;
      }

      context.drawImage(element, pos.x, pos.y, radius * 2, radius * 2 / ratio);

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = 1;
      }
    }
  }, {
    key: "loadShape",
    value: function loadShape(particle) {
      var _a, _b, _c, _d, _e, _f, _g;

      if (particle.shape !== "image" && particle.shape !== "images") {
        return;
      }

      var images = this.getImages(particle.container).images;
      var imageData = particle.shapeData;
      var image = (_a = images.find(function (t) {
        return t.source === imageData.src;
      })) !== null && _a !== void 0 ? _a : images[0];
      var color = particle.getFillColor();
      var imageRes;

      if (!image) {
        return;
      }

      if (image.svgData !== undefined && imageData.replaceColor && color) {
        var svgColoredData = (0, Utils_2.replaceColorSvg)(image, color, (_c = (_b = particle.opacity) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 1);
        var svg = new Blob([svgColoredData], {
          type: "image/svg+xml"
        });
        var domUrl = URL || window.URL || window.webkitURL || window;
        var url = domUrl.createObjectURL(svg);
        var img = new Image();
        imageRes = {
          data: Object.assign(Object.assign({}, image), {
            svgData: svgColoredData
          }),
          ratio: imageData.width / imageData.height,
          replaceColor: (_d = imageData.replaceColor) !== null && _d !== void 0 ? _d : imageData.replace_color,
          source: imageData.src
        };
        img.addEventListener("load", function () {
          var pImage = particle.image;

          if (pImage) {
            pImage.loaded = true;
            image.element = img;
          }

          domUrl.revokeObjectURL(url);
        });
        img.addEventListener("error", function () {
          domUrl.revokeObjectURL(url);
          (0, Utils_2.loadImage)(imageData.src).then(function (img2) {
            var pImage = particle.image;

            if (pImage) {
              image.element = img2 === null || img2 === void 0 ? void 0 : img2.element;
              pImage.loaded = true;
            }
          });
        });
        img.src = url;
      } else {
        imageRes = {
          data: image,
          loaded: true,
          ratio: imageData.width / imageData.height,
          replaceColor: (_e = imageData.replaceColor) !== null && _e !== void 0 ? _e : imageData.replace_color,
          source: imageData.src
        };
      }

      if (!imageRes.ratio) {
        imageRes.ratio = 1;
      }

      var fill = (_f = imageData.fill) !== null && _f !== void 0 ? _f : particle.fill;
      var close = (_g = imageData.close) !== null && _g !== void 0 ? _g : particle.close;
      var imageShape = {
        image: imageRes,
        fill: fill,
        close: close
      };
      particle.image = imageShape.image;
      particle.fill = imageShape.fill;
      particle.close = imageShape.close;
    }
  }]);

  return ImageDrawer;
}();

exports.ImageDrawer = ImageDrawer;
_ImageDrawer_images = new WeakMap();